import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Section, TextColumn, Automec, TextoAbaixo } from "./../styles/styles";

import povao from "./../styles/overview1.png";
import coisas from "./../styles/overview2.png";
import poteMarca from "./../styles/overview3.png";
import poteblender from "./../styles/poteblender.png";
import poteresult from "./../styles/poteresultado.png";

const Projeto3d = () => {
  const conteudos = [
    {
      titulo: "Overview",
      desc: [
        {
          title: "File Organization & Copywriting:",
          text: " I was responsible for the end-to-end visual development of the brand's product line. I standardized the company’s file organization and consistency from the ground up, creating a scalable system for marketing assets. My workflow covered everything from product compound analysis and precise bottle measuring to technical coordination with the chemistry and product teams.Throughout this period, I delivered over 400 visual assets, including 39 3D models, 30 packaging designs, and 270 high-quality renders. Beyond digital assets, I managed the visual production for 3 major trade shows, including full 3D stand modeling and the creation of all event-related graphic materials.",
        },
        {
          title: "ROLE:",
          text: "Graphic and 3D Designer",
        },
        {
          title: "RESPONSIBILITIES:",
          text: "Brand Consistency, Product Analysis, Graphic Materials Creation, 3D Modeling, Material Creation and Rendering and Marketing Asset Management",
        },
      ],
      img: povao,
    },
    {
      titulo: "Challenge",
      desc: [
        {
          text: " When Chemicals4You launched, it struggled with inconsistent visual assets and disorganized design files. The main bottleneck was the inability to photograph products still in the labeling or production phases, which delayed both the e-commerce launch and marketing efforts.",
        },
      ],
      img: coisas,
    },
    {
      titulo: "Solution",
      desc: [
        {
          title: "File Organization & Copywriting:",
          text: "I audited and restructured all existing label files, ensuring technical accuracy and consistent brand messaging across the product line.",
        },
        {
          title: "Grid Systems:",
          text: "Establishing a rigid structure for text hierarchy and element organization.",
        },
        {
          title: "Print Readiness:",
          text: "Every file was built strictly following brand guidelines and technical die-lines provided by the printing house to ensure zero production errors.",
        },
      ],
      img: poteblender,
    },
    {
      titulo: "Solution",
      desc: [
        {
          title: "High-Precision 3D Prototyping:",
          text: "To ensure accuracy, I performed physical measurements on every product container.",
        },
        {
          title: "Dynamic Rendering Pipeline:",
          text: "I created a plug-and-play system within Blender to streamline production.",
        },
        {
          title: "Effortless Iteration:",
          text: "Once the 3D scene was set, it became possible to instantly swap label textures and generate new assets.",
        },
        {
          title: "Efficiency:",
          text: "This automated workflow allowed the company to generate professional marketing content for the entire catalog in a fraction of the traditional time.",
        },
      ],
      img: poteMarca,
    },
    {
      titulo: "Results",
      desc: [
        {
          title: "Efficiency:",
          text: "Legacy workflows were transformed into an organized and scalable production system.",
        },
        {
          title: "Output:",
          text: "Over 400 visual assets were produced, including 3D models, renders, and photography.",
        },
        {
          title: "Growth:",
          text: "Deep expertise in brand strategy and technical coordination was developed.",
        },
        {
          title: "Standardization:",
          text: "A unified file structure was created, giving the team clarity and flexibility for future campaigns.",
        },
      ],
      img: poteresult,
    },
  ];

  const containerRef = useRef(null);
  const [dragWidth, setDragWidth] = useState(0);

  useEffect(() => {
    const calcularWidth = () => {
      if (!containerRef.current) return;

      const scrollWidth = containerRef.current.scrollWidth;
      const offsetWidth = containerRef.current.offsetWidth;

      setDragWidth(scrollWidth - offsetWidth);
    };

    calcularWidth();

    window.addEventListener("resize", calcularWidth);
    return () => window.removeEventListener("resize", calcularWidth);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <motion.div
        drag="x"
        dragConstraints={{ left: -dragWidth, right: 0 }}
        dragElastic={0.1}
        dragMomentum={false}
        style={{
          display: "flex",
          width: "max-content",
          cursor: "grab",
        }}
        whileTap={{ cursor: "grabbing" }}
      >
        {conteudos.map((item, index) => (
          <Section
            key={index}
            style={{
              width: "1500",
              flexShrink: 0,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingLeft: "40px",
              boxSizing: "border-box",
            }}
          >
            <img
              src={item.img}
              alt={item.titulo}
              draggable={false}
              style={{
                width: "auto",
                height: "70vh",
                marginLeft: "200px",
                pointerEvents: "none",
                userSelect: "none",
                borderRadius: "20px",
              }}
            />
            <TextColumn>
              <Automec>{item.titulo}</Automec>

              <TextoAbaixo>
                {item.desc.map((bloco, i) => (
                  <p key={i}>
                    {bloco.title && <strong>{bloco.title}</strong>} {bloco.text}
                  </p>
                ))}
              </TextoAbaixo>
            </TextColumn>
          </Section>
        ))}
      </motion.div>
    </div>
  );
};

export default Projeto3d;
